import { useAdministrationArea } from "../../../providers/administrationAreaProvider";

import { JSX } from "react";

import { Chip } from "@mui/material";

export default function DevAdministrationAreaIndicator(): JSX.Element | null {
  const { administrationArea } = useAdministrationArea();

  return (
    <Chip
      size="small"
      variant="outlined"
      color={administrationArea ? "success" : "warning"}
      label={`administration area: ${administrationArea || "none"}`}
    />
  );
}
